import React, { useState } from 'react';
import { ModalWrapper } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Space, Table } from 'antd';
import { TotalNumMenu } from 'components/atoms';
import { useTableInfo, useCrmList } from 'hooks';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';

export interface CrmListModalProps extends PopupProps {
    company_srl: number;
    company: string;
}

const CrmListModal = ({ isOpen, onClose, company_srl, company }: CrmListModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [pageNo, setPageNo] = useState<number>(1);
   /* ======================================================
   * variables
   * ====================================================== */
   const columns: ColumnsType<CrmListDto> = [
    {
      title: '이름(구분)',
      dataIndex: 'name',
      key: 'name',
      width: 'auto',
      align: 'left',
      ellipsis: true,
      render: (name, record) => {
       return (
         <>
           {name}{record.crm_type_name && '('+record.crm_type_name+')'}
         </>        
       )
      }       
    },
    {
     title: '전화번호',
     dataIndex: 'tel',
     key: 'tel',
     width: '120px',
     align: 'center',
     ellipsis: true,
   },   
   {
     title: '핸드폰',
     dataIndex: 'phone',
     key: 'phone',
     width: '120px',
     align: 'center',
     ellipsis: true,
   },     
    {
      title: '이메일',
      dataIndex: 'email',
      key: 'email',
      width: '190px',
      align: 'left',
      ellipsis: true,
    },
    {
     title: '직급',
     dataIndex: 'position',
     key: 'position',
     width: '80px',
     align: 'center',
     ellipsis: true,
   },   
    {
     title: '부서',
     dataIndex: 'department',
     key: 'department',
     width: '130px',
     align: 'center',
     ellipsis: true,
   },
  ];
   /* ======================================================
   * events
   * ====================================================== */
   const onChangePageInfo = (pageNo: number, pageSize: number) => {
    setPageNo(pageNo);
   };
  /* ======================================================
   * hooks
   * ====================================================== */
  const { crmList, searchResult } = useCrmList({pageNo: pageNo, pageSize:10, company: company_srl}); 

  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: pageNo || 1,
      pageSize: 10,
    },
    datas: crmList,
    totalCount: searchResult.totalCount,
    showSizeChanger: false,
    onChangePageInfo,
  }); 
   
  /* ======================================================
   * effects
   * ====================================================== */

    return (
        <ModalWrapper open={isOpen} onCancel={onClose} width={800} title={'CRM 목록'} closable>
            <Space direction="vertical" style={{ width: '100%' }}>
                <TotalNumMenu text={company + ' 기업에 소속된 CRM 인원은 총 '+searchResult.totalCount+' 명입니다.'}/>
                <TableWrapper isSearch={false}>
                    <Table
                        tableLayout="fixed"
                        dataSource={crmList}
                        columns={columns}
                        pagination={pagination}
                        onChange={onTableChange}
                        style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                        showSorterTooltip={false}
                        rowKey={'id'}
                    />
                </TableWrapper>
            </Space>     
        </ModalWrapper>  
    )    
};

export default React.memo(CrmListModal);    